/**
 * 复习提醒（艾宾浩斯曲线，纯前端 localStorage，无后端、无账号体系）
 * - key: aid-read-history
 * - 数据结构: [{ push_date, title, topic_type, read_time }]
 * - 逻辑：读完后按 1/2/4/7/15 天提醒复习；距今天数命中任一间隔即到期
 */
import { reactive } from 'vue'

const KEY = 'aid-read-history'
const INTERVALS = [1, 2, 4, 7, 15]

function load () {
  try {
    const raw = localStorage.getItem(KEY)
    const arr = raw ? JSON.parse(raw) : []
    return Array.isArray(arr) ? arr.filter(it => it && it.push_date && it.read_time) : []
  } catch (e) {
    return []
  }
}

// 全局响应式状态
export const readState = reactive({ items: load() })

function persist () {
  localStorage.setItem(KEY, JSON.stringify(readState.items))
}

/** 标记已读（重复阅读刷新 read_time，重新开始复习周期） */
export function markRead (item) {
  if (!item || !item.push_date) return
  const idx = readState.items.findIndex(it => it.push_date === item.push_date)
  const rec = {
    push_date: item.push_date,
    title: item.title || '',
    topic_type: item.topic_type || '',
    read_time: Date.now()
  }
  if (idx >= 0) {
    readState.items.splice(idx, 1, rec)
  } else {
    readState.items.unshift(rec)
  }
  persist()
}

/** 距今天数（按自然日） */
function daysSince (ts) {
  const now = new Date()
  now.setHours(0, 0, 0, 0)
  const then = new Date(ts)
  then.setHours(0, 0, 0, 0)
  return Math.round((now - then) / 86400000)
}

/**
 * 今日待复习列表：距今 1/2/4/7/15 天的已读笔记
 * 返回 [{ push_date, title, topic_type, days }]（days 升序）
 */
export function dueList () {
  const out = []
  for (const it of readState.items) {
    const d = daysSince(it.read_time)
    if (INTERVALS.includes(d)) {
      out.push({ push_date: it.push_date, title: it.title, topic_type: it.topic_type, days: d })
    }
  }
  return out.sort((a, b) => a.days - b.days)
}

export default { readState, markRead, dueList }
